import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type CircleProps = {
	children: ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

const Circle = ({ children, className, ...props }: CircleProps) => {
	return (
		<div
			className={twMerge(
				'flex h-5 w-5 items-center justify-center rounded-full bg-black/30 font-medium text-[10px] text-mantang-black',
				className,
			)}
			{...props}
		>
			{children}
		</div>
	);
};

export default Circle;
